import React, { FC, Suspense } from 'react'

import { useTypedSelector } from '@hooks/common/useTypedSelector'

import { lazyImport } from '@utils/lazyImport'

const { KinozalContinueWatching } = lazyImport(
  () =>
    import(
      /*webpackChunkName: 'kinozal-continue-watching'*/ '@components/Dialogs/ContinueWatching/KinozalContinueWatching/KinozalContinueWatching'
    ),
  'KinozalContinueWatching'
)

export const LazyKinozalContinueWatching: FC = () => {
  const isOpened = useTypedSelector(
    (state) => state.dialogs.confirm.kinozalContinueWatching.isOpened
  )
  
  if (!isOpened) return null

  return (
    <Suspense fallback={null}>
      <KinozalContinueWatching />
    </Suspense>
  )
}
